export type AdminProjectItem = {
  id: number;
  title: string;
  summary: string;
  description: string;
  cost: number;
  materialCost: number;
  slug: string;
  image: string;
  addedOn: string | null;
};

export type AdminProjectsResponse = {
  projects: AdminProjectItem[];
  pagination: {
    page: number;
    pageSize: number;
    totalProjects: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
  };
  summary: {
    totalProjects: number;
    withImageProjects: number;
    totalProjectValue: number;
    totalMaterialCost: number;
  };
};

export type AdminProjectInput = {
  title: string;
  summary?: string;
  description?: string;
  cost: number;
  slug?: string;
  image?: string;
  materialCost: number;
};

async function parseResponse(response: Response) {
  const data = await response.json().catch(() => null);
  if (!response.ok) {
    throw new Error(data?.message || `Request failed: ${response.status}`);
  }

  return data;
}

export async function fetchAdminProjects(query: URLSearchParams) {
  const response = await fetch(`/api/admin/projects?${query.toString()}`, {
    credentials: "include",
    headers: {
      Accept: "application/json"
    }
  });

  return (await parseResponse(response)) as AdminProjectsResponse;
}

export async function fetchAdminProject(projectId: number) {
  const response = await fetch(`/api/admin/projects/${projectId}`, {
    credentials: "include",
    headers: {
      Accept: "application/json"
    }
  });

  return (await parseResponse(response)) as AdminProjectItem;
}

export async function createAdminProject(input: AdminProjectInput) {
  const response = await fetch("/api/admin/projects", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json"
    },
    body: JSON.stringify(input)
  });

  return parseResponse(response);
}

export async function updateAdminProject(projectId: number, input: AdminProjectInput) {
  const response = await fetch(`/api/admin/projects/${projectId}`, {
    method: "PUT",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json"
    },
    body: JSON.stringify(input)
  });

  return parseResponse(response);
}
